module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/bot_button_en.22525b1e.png";